// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"21b49c42","323":"0bb10aff","393":"dc5a6348","422":"5c56c890","544":"9d57dbbf"}[chunkId] + ".chunk.js";
};